var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-avatar',{staticClass:"user-avatar",attrs:{"size":_vm.avatarSize}},[(_vm.url)?_c('img',{attrs:{"src":_vm.avatarImageUrl}}):_c('v-icon',{attrs:{"size":_vm.iconSize,"color":"rgba(0,0,0,0.6)"}},[_vm._v("mdi-account")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }